import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';

export interface DropdownOption {
  label: string;
  value: any;
  disabled?: boolean;
}

@Component({
  selector: 'ebo-dropdown',
  templateUrl: './ebo-dropdown.component.html',
  styleUrls: ['./ebo-dropdown.component.scss']
})
export class EboDropdownComponent implements OnInit, OnChanges {
  @Input() title: string;
  @Input() placeholder = 'Select an option';
  @Input() options: DropdownOption[] = [];
  @Input() disabled = false;
  @Input() required = false;
  @Input() error = '';
  @Input() hint = '';
  @Input() value: any = null;

  @Output() selectionChange = new EventEmitter<any>();

  selectedValue: any = null;
  isOpen = false;
  isFocused = false;

  constructor() {}

  ngOnInit(): void {
    // Initialize with the input value
    if (this.value !== null && this.value !== undefined) {
      this.selectedValue = this.value;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Update selectedValue when value input changes
    if (changes.value && changes.value.currentValue !== undefined && changes.value.currentValue !== null) {
      this.selectedValue = changes.value.currentValue;
    }
  }

  toggleDropdown(): void {
    if (!this.disabled) {
      this.isOpen = !this.isOpen;
    }
  }

  selectOption(option: DropdownOption): void {
    if (!option.disabled && !this.disabled) {
      this.selectedValue = option.value;
      this.isOpen = false;

      // Emit the selection change event
      this.selectionChange.emit(option.value);
    }
  }

  getSelectedLabel(): string {
    if (this.selectedValue === null || this.selectedValue === undefined) {
      return this.placeholder;
    }

    const selected = this.options.find(opt => opt.value === this.selectedValue);
    return selected ? selected.label : this.placeholder;
  }

  onBlur(): void {
    this.isFocused = false;
    setTimeout(() => {
      this.isOpen = false;
    }, 200);
  }

  /** trackBy for options *ngFor – prevents DOM destruction when options array reference changes */
  trackByValue(_index: number, option: DropdownOption): any {
    return option.value;
  }
}
